import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyDT_owfP4VsHzeo6YqAf2jDSk-UpDJD7fc",
  authDomain: "connector-40c28.firebaseapp.com",
  projectId: "connector-40c28",
  storageBucket: "connector-40c28.appspot.com",
  messagingSenderId: "1019204034291",
  appId: "1:1019204034291:web:5a5a2fec1bc2c505dae186",
  measurementId: "G-YQZGRB4VSM"
};

const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

export default app;